// css resource takes scope selector, that basically gives scope to loaded css
// it replaces scope placeholder (#scope) with given scope selector
import { Get } from ".././MyHelpers";
import { Resource } from "./Resource";
import { ResourceIdentifier } from "./ResourceIdentifier";
export class CSSResource extends Resource
{
	get Name(): string {
		return this.name;
	}
	get Type(): string {
		return "css";
	}
	
	private parent: HTMLElement = null;
	private cssElem: HTMLElement = null;
	private scopeSelector: string = "#noscope";


	private static readonly scopePlaceholder: RegExp = /\#scope/g;

	public constructor(path: string, name: string = null, scopeSelector: ResourceIdentifier | string, parent: HTMLElement = null, required: boolean = true) {
		super(path, name, required)

		if (scopeSelector instanceof ResourceIdentifier)
		{
			this.scopeSelector = scopeSelector.CSSScope();
		}
		else
		{
			this.scopeSelector = scopeSelector;
		}

		if (parent == null) {
			parent = document.querySelector("head");
		}

		this.parent = parent;
	}

	public Load(preventCache: boolean = false): void {

		this.cssElem = document.createElement("style");
		this.cssElem.setAttribute("name", this.name);
		this.cssElem.setAttribute("data-path", this.path );
		this.cssElem.setAttribute("type", "text/css");

		//this.cssElem.setAttribute("scoped", "");
		Get.Text(
			this.path ,
			(success: boolean, status: number, response: string) => {
				if (success) {
					// scope css to specific scope selector, if any
					let scoped: string = response.replace(CSSResource.scopePlaceholder, this.scopeSelector);

					this.cssElem.innerHTML = scoped;

					this.Loaded();
				}
				else {
					this.LoadError();
				}
		});

		this.parent.appendChild(this.cssElem);
	}

	public override Reload(preventCache: boolean = false): void {
		try
		{
			this.parent.removeChild(this.cssElem);
		} catch (ex) {}

		this.Load(preventCache);
	}

	// no need anymore for changing parent
	// "scope" tag is not yet supported, so does not matter in what parent css is
	ChangeParent(newParent: HTMLElement) {
		this.parent = newParent;
		this.parent.appendChild(this.cssElem);
	}
}